import React from 'react';
import Popup from 'reactjs-popup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useQuoteAwning } from '../Store/entities/awnings/hooks';
import { setAwningsSelected, setAwningsUnlocked } from '../Store/entities/awnings';
import { useQuoteById } from '../Store/entities/quotes/hooks';
import type { AppDispatch } from '../Store';

type QuoteAwningLockSelectProps = {
	quoteId: number;
	lineNumber: number;
	unlockQuoteForEditing: () => void;
};

const QuoteAwningLockSelect = ({
	quoteId,
	lineNumber,
	unlockQuoteForEditing,
}: QuoteAwningLockSelectProps) => {
	const dispatch = useDispatch<AppDispatch>();
	const quoteIsEditable = useQuoteById(quoteId)?.editable ?? false;
	const awning = useQuoteAwning(quoteId, lineNumber);

	const selected = awning?.selected ?? false;
	const unlockedStore = awning?.unlocked ?? false;
	const unlocked = unlockedStore && quoteIsEditable;
	const isErrored = awning?.msrp === 0;

	let classNameUnlock = unlocked ? '' : 'icon-lock CEDIA';
	let classNameLock = unlocked ? ' ' : 'icon-unlock CEDIA';

	const onLockClick = () => {
		if (!quoteIsEditable) {
			unlockQuoteForEditing();
			return;
		}

		if (unlocked) {
			dispatch(setAwningsSelected({
				quoteId,
				lineNumbers: [lineNumber],
				selected: !selected,
			}));
		} else {
			dispatch(setAwningsUnlocked({
				quoteId,
				lineNumbers: [lineNumber],
				unlocked: true,
			}));
		}
	};

	return (
		<Popup
			key={`awning-lock-${lineNumber}`}
			trigger={(
				<span
					onClick={onLockClick}
					className="fa-stack lock CEDIA"
					role="button"
					tabIndex={0}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') onLockClick();
					}}
				>
					<span className="fa-layers fa-fw">
						<FontAwesomeIcon className={classNameUnlock} transform="grow-10 right-4" icon={faLockOpen} />
						{unlocked ? null : <FontAwesomeIcon className={classNameLock} transform="grow-10" icon={faLock} />}
						{!selected ? null : (
							<FontAwesomeIcon icon={faCheck} transform="shrink-4 right-1 down-6" color="blue" />
						)}
					</span>
				</span>
			)}
			position={['right center']}
			on={['hover', 'focus']}
		>
			<div>{isErrored ? 'Unlock to edit or reprice awning' : 'Edit or unlock awning'}</div>
		</Popup>
	);
};

export default QuoteAwningLockSelect;
